export const AUTH_USER = 'AUTH_USER';
export const AUTH_USER_OUT = 'AUTH_USER_OUT';
export const SIGH_UP_USER = 'SIGH_UP_USER';
export const FORGOT_PASSWORD = 'USER/FORGOT_PASSWORD';
export const UPDATE_PASSWORD = 'USER/UPDATE_PASSWORD';



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js